import { Component } from '@angular/core';

@Component({
  selector: 'wl-query-tool-advanced',
  templateUrl: './query-tool-advanced.component.html',
  styleUrls: ['./query-tool-advanced.component.less'],
    standalone: false
})
export class QueryToolAdvancedComponent {

}
